module.exports = __webpack_public_path__ + "img/tiempoReal.9feb4cfa.svg";